import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { END } from 'redux-saga'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { wrapper } from '@/Store/index'
import { loadSelf } from '@fdn/profile_store'
import Router from 'next/router'
import MetaHeader from 'Containers/meta_header'
import Env from 'Consts/env'
import { fetchWithCache } from 'Helpers/fetch'
import { loadEditorialTag } from '@/Store/editorial_tag_store/lib/actions'
import { scrollToId, slugUrl, stringUrl, handleUrlArticle, ads_detik } from 'Helpers/utils'
import { fetchAds } from 'Helpers/fetchAds'
const cookie = require('cookie')
const Breadcrumb = dynamic(() => import('@fdn/breadcrumb'))
const Pagination = dynamic(() => import('@fdn/pagination'), {
  ssr: false,
})
const Sidebar = dynamic(() => import('Components/sidebar'), {
  ssr: true,
})
const Banner = dynamic(() => import('Components/banner/banner'), {
  ssr: false,
})
const Layout = dynamic(() => import('Containers/layout'), {
  ssr: true,
})
const ArticleCardHome = dynamic(() => import('Components/article_card_home'), {
  ssr: false,
})
const Section404 = dynamic(() => import('Components/error/404'), { ssr: false })
const ShimmerArticle = dynamic(() => import('Components/shimmer/articles'))

const TagArticles = (props) => {
  const isMobile = props.is_mobile
  const dispatch = useDispatch()
  const router = useRouter()
  const { page, tagslug } = router.query
  const storeData = useSelector((state) => state)

  const HandleUpdatePagination = (pageParam) => {
    scrollToId('heading')

    const path = window.location.pathname

    Router.push(
      {
        pathname: `/blog/tag/${tagslug.toString().replace(',', '/')}`,
        query: {
          page: pageParam,
        },
      },
      `${path}?page=${pageParam}`,
      { shallow: true },
    )
  }

  useEffect(() => {
    if (router.isReady) {
      console.log('loadEditorialTag',);
      dispatch(
        loadEditorialTag({
          slug: slugUrl(tagslug),
          limit: '10',
          page: page || 1,
          env: Env.HEADERS,
        }),
      )
    }
  }, [router.isReady, page, tagslug])

  return (
    <Layout
      home
      page_type="articlelist"
      title={tagslug && stringUrl(tagslug).toUpperCase()}
      is_mobile={isMobile}
      self={storeData.storeSelf}
      ads_head={props.adsHead}
      ads_foot={props.adsFoot}
    >
      <MetaHeader
        url={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/tag/${tagslug && tagslug}`}
      />
      <main id="main-content">
        <section id="page-heading">
          {(props.ads.staticbanner1 || props.ads.billboard) ?
            <Banner
              name={!!isMobile ? 'staticbanner1' : 'billboard'}
              placeholder={!!isMobile ? 'staticbanner1' : 'billboard'}
              is_mobile={isMobile}
              class_name="ads-billboard"
              dataAds={!!isMobile ? props.ads?.staticbanner1 : props.ads?.billboard}
            />
            : null
          }
          <div className="image-heading" id="heading">
            <p className="text-heading">
              {tagslug ? stringUrl(tagslug).toUpperCase() : null}
            </p>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <Breadcrumb
                  is_mobile={isMobile}
                  breadcrumbs={[tagslug ? router?.query?.tagslug : '404']}
                  destinationUrl={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/category`}
                  fontFamily="Roboto"
                />
              </div>
            </div>
          </div>
        </section>
        <section id="page-content">
          <div className="container">
            <div className="row">
              <div className="col article">
                <div className="article-list">
                  {storeData.storeEditorialTag?.status === 'fetch_result' &&
                    storeData.storeEditorialTag?.data?.data?.length > 0 ? (
                    storeData.storeEditorialTag?.data?.data?.map(
                      (item, idx) => (
                        <div key={String(idx)} className="article-card-wrapper">
                          <ArticleCardHome
                            is_mobile={isMobile}
                            is_sponsored={false}
                            font_title={`Josefin Sans, sans-serif`}
                            article={Object.assign({
                              category: {
                                name: tagslug.replace(/[-]/g, ' '),
                              },
                              date: item.created_at,
                              title: item.title,
                              text: item.excerpt,
                              image: item.image,
                              url: handleUrlArticle(item.url),
                              author: { fullname: item.author.name },
                            })}
                            url_category="#"
                            url_author={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/author/${item.author.username}`}
                            type={!isMobile ? 'type-5' : 'type-2'}
                          />
                        </div>
                      ),
                    )
                  ) : ['fetch_init', 'fetch_loading'].includes(storeData.storeEditorialTag?.status) ? (
                    Array.from({ length: 10 }).map((_, idx) => (
                      <ShimmerArticle key={idx} isMobile={isMobile} />
                    ))
                  ) : (
                    <Section404 text="data" />
                  )}
                </div>
                {!!storeData.storeEditorialTag?.data && (
                  <div className="pagination-wrapper">
                    <Pagination
                      is_mobile={isMobile}
                      page={page || '1'}
                      total_page={
                        storeData.storeEditorialTag?.data?.pagination
                          ?.total_page
                      }
                      update_page={HandleUpdatePagination}
                    />
                  </div>
                )}
              </div>
              {!isMobile ? (
                <div className="col sidebar-body-wrapper">
                  <Sidebar
                    popularArticles={props.resPopularArticles}
                    beautyFiles={props.resBeautyFiles}
                    video={
                      slugUrl(tagslug ? tagslug : ['']).includes('video-blog')
                        ? { data: { data: [] } }
                        : props.resVideos
                    }
                    is_mobile={isMobile}
                  />
                </div>
              ) : (
                <div className="ads-bottom-wrapper">
                  <Banner
                    name="staticbanner2"
                    placeholder="staticbanner2"
                    is_mobile={isMobile}
                    dataAds={props.ads?.staticbanner2}
                    class_name="ads-medium-rectangle2"
                  />
                </div>
              )}
            </div>
          </div>
        </section>
        <style jsx global>
          {`
            .row {
              display: flex;
              flex-wrap: wrap;
            }
            .ads-billboard {
              margin-top: 0;
              align-items: center;
              display: flex;
              justify-content: center;
            }
            .ads-billboard:has(iframe),
            .ads-billdboard:has(a) {
              margin-top: ${isMobile ? '0px' : '66px'};
            }
            .paging-prev-text-active,
            .paging-prev-text-inactive,
            .paging-button,
            .paging-button-dots,
            .paging-button-active {
              font-family: Roboto, sans-serif !important;
              font-size: 12px !important;
            }
            .paging-totop,
            .button-to-top {
              display: none !important;
            }
            .paging-button,
            .paging-button-active,
            .paging-button-dots {
              border: 1px solid #DFE3E8 !important;
              border-radius: 0 !important;
              margin: 0 3px !important;
            }
            .paging-button-active {
              background-color: #DB284E !important;
              color: #FFF !important;
              font-weight: 600 !important;
              border-color: #DB284E !important;
            }
            .paging-list-number {
              padding: 0 8px !important;
            }
          `}
        </style>
        <style jsx>
          {`
            #main-content {
              margin: 24px 0 62px;
            }

            #page-content {
              padding-top: 24px;
            }

            .container {
              ${isMobile ? `
              padding-left: 15px;
              padding-right: 15px;
              ` : `
              width: calc(100% - 30px);
              max-width: 1200px;
              margin: 0 auto;
              padding: 0 15px !important;
              `}
            }

            .col.article {
              width: calc(100% - 380px);
              max-width: calc(100% - 380px);
              margin-right: 80px;
            }

            .col.sidebar-body-wrapper {
              width: 300px;
              max-width: 300px;
            }

            .article-card-wrapper {
              height: ${isMobile ? '100px' : '290px'};
              border-bottom: 1px solid #dfe3e8;
              padding-bottom: 20px;
              margin-bottom: 40px;
            }

            .image-heading {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              background-image: url(https://image.femaledaily.com/editorial/banner-header/header-img.png);
              background-repeat: no-repeat;
              background-size: cover;
              height: 80px;
              box-sizing: border-box;
            }

            .text-heading {
              margin: 0;
              padding: 0;
              font-family: Josefin Sans, sans-serif;
              font-weight: 600;
              font-size: 24px;
              line-height: 32px;
              color: #fff;
              text-transform: uppercase;
            }

            @media (max-width: 800px) {
              #page-heading {
                padding-bottom: 0;
                border-bottom: 0;
              }
              .col.article {
                width: 100%;
                max-width: 100%;
                margin-right: 0;
              }
              .ads-bottom-wrapper {
                margin-top: 52px;
                width: 100%;
                text-align: center;
              }
              .ads-bottom-wrapper:empty {
                margin-top: 0;
              }
            }
          `}
        </style>
      </main>
    </Layout>
  )
}

export const getServerSideProps = wrapper.getServerSideProps(
  async ({ store, req, res, query }) => {

    let userAgent
    if (req) {
      // if you are on the server and you get a 'req' property from your context
      userAgent = req.headers['user-agent'] // get the user-agent from the headers
    } else {
      userAgent = navigator.userAgent // if you are on the client you can access the navigator from the window object
    }

    let is_mobile =
      !!userAgent &&
      Boolean(
        userAgent.match(
          /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
        ),
      )
    let cookies,
      authorization = null,
      usrname = null

    const isServer = !!req
    if (req.headers.cookie) {
      cookies = cookie.parse(req.headers.cookie)
      authorization = cookies.token
      usrname = cookies.usrname
    }

    if (authorization) {
      await store.dispatch(
        loadSelf({
          payload: {
            api_env: process.env.NEXT_PUBLIC_NODE_ENV,
            env: Env.HEADERS,
            Authorization: authorization,
            is_server: isServer,
            is_allo: process.env.NEXT_PUBLIC_ALLO_STATUS === "ON",
          },
        }),
      )
    }

    store.dispatch(END)
    await store.sagaTask.toPromise()

    let site = is_mobile === true ? 'mobile' : 'desktop'

    let adsHead = null
    let adsFoot = null

    let ads = {
      billboard: null,
      staticbanner1: null,
      staticbanner2: null,
      mediumrectangle1: null,
      mediumrectangle2: null,
    }

    const result = await Promise.allSettled([
      // ads Detik
      ads_detik(site, 'taghead'),
      ads_detik(site, 'tagfoot'),

      // fetch Ads
      ...(is_mobile
        ? [
          fetchAds('staticbanner1', true),
          fetchAds('staticbanner2', true),
        ]
        : [
          fetchAds('billboard', false),
          fetchAds('mediumrectangle1', false),
          fetchAds('mediumrectangle2', false),
        ]),
    ])

    if (result[0].status === 'fulfilled') {
      adsHead = result[0].value
    }

    if (result[1].status === 'fulfilled') {
      adsFoot = result[1].value
    }

    if (is_mobile) {
      ads = {
        billboard: null,
        mediumrectangle1: null,
        mediumrectangle2: null,
        staticbanner1: result[2].status === 'fulfilled' ? result[2].value : null,
        staticbanner2: result[3].status === 'fulfilled' ? result[3].value : null,
      }
    } else {
      ads = {
        billboard: result[2].status === 'fulfilled' ? result[2].value : null,
        mediumrectangle1: result[3].status === 'fulfilled' ? result[3].value : null,
        mediumrectangle2: result[4].status === 'fulfilled' ? result[4].value : null,
        staticbanner1: null,
        staticbanner2: null,
      }
    }

    let resBeautyFiles = null
    let resVideos = null
    let resPopularArticles = null

    if(site !== 'mobile') {
      const sideBar = await Promise.allSettled([
        fetchWithCache(
          process.env.NEXT_PUBLIC_BEAUTY_FILES,
          24,
        ),
        fetchWithCache(
          `${process.env.NEXT_PUBLIC_ARTICLE}/category/video-blog?limit=4`,
        ),

        fetchWithCache(
          `${process.env.NEXT_PUBLIC_POPULAR_ARTICLE}?limit=4`,
        ),
      ]);

      resBeautyFiles = sideBar?.[0]?.status === 'fulfilled' && typeof sideBar?.[0]?.value !== 'undefined' ? sideBar?.[0]?.value : [];
      resVideos = sideBar?.[1]?.status === 'fulfilled' && typeof sideBar?.[1]?.value !== 'undefined' ? sideBar?.[1]?.value : [];
      resPopularArticles = sideBar?.[2]?.status === 'fulfilled' && typeof sideBar?.[2]?.value !== 'undefined' ? sideBar?.[2]?.value : [];
    }
    

    return {
      props: {
        is_mobile,
        adsHead,
        adsFoot,
        ads,
        resVideos,
        resBeautyFiles,
        resPopularArticles,
      },
    }
  })

export default TagArticles
